import {ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAuth} from './core/auth/auth.config';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authHttpInterceptorFn} from '@auth0/auth0-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAuth(),
    provideHttpClient(withInterceptors([authHttpInterceptorFn]))
  ]
};
